import { useState } from 'react';
import { Layers } from 'lucide-react';
import { signIn } from '../api/msal';

interface SignInScreenProps {
  onSignedIn: () => void;
}

export function SignInScreen({ onSignedIn }: SignInScreenProps) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setBusy(true);
    setError(null);
    try {
      await signIn();
      onSignedIn();
    } catch (e: any) {
      setError(e?.message || 'Sign-in failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 p-8 text-center">
        <div className="w-12 h-12 rounded-lg bg-accent-600 flex items-center justify-center mx-auto mb-4">
          <Layers className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-1">Slide Library</h1>
        <p className="text-sm text-gray-600 mb-6">
          Browse and manage your organisation&apos;s curated decks.
        </p>
        <button
          onClick={handleSignIn}
          disabled={busy}
          className="w-full px-4 py-2.5 text-sm bg-accent-600 hover:bg-accent-700 disabled:bg-accent-400 text-white rounded font-medium"
        >
          {busy ? 'Signing in…' : 'Sign in with Microsoft'}
        </button>
        {error && (
          <p className="mt-4 text-xs text-red-600">{error}</p>
        )}
        <p className="mt-6 text-xs text-gray-500">
          Inserting slides into a presentation requires opening the add-in inside PowerPoint.
          This page lets you browse and manage the library from any browser.
        </p>
      </div>
    </div>
  );
}
